import { isAllowedTag, sanitizeSignal } from './signals'
import { UserJourneyAction, UserJourneyState } from './types'

export const userJourneyReducer = (state: UserJourneyState, action: UserJourneyAction): UserJourneyState => {
  const journeyExists = action.name in state.journeys

  switch (action.type) {
    case 'USER_JOURNEY_START': {
      const newJourney = {
        id: action.id,
        name: action.name,
        created: action.created ?? new Date().getTime(),
        variant: undefined,
        frustrations: [],
        frictions: [],
        tags: [],
      }

      const newHistory = state.history.length > 0 ? [...state.history.filter((journey) => journey !== newJourney.name), newJourney.name] : [newJourney.name]

      return {
        history: newHistory,
        active: action.name,
        journeys: {
          ...state.journeys,
          [action.name]: newJourney,
        },
      }
    }
    case 'USER_JOURNEY_RESUME': {
      if (journeyExists) {
        return state
      }

      return {
        history: [...state.history.filter((journey) => journey !== action.journey.name), action.journey.name],
        active: action.journey.name,
        journeys: {
          ...state.journeys,
          [action.journey.name]: action.journey,
        },
      }
    }
    case 'USER_JOURNEY_COMPLETE': {
      if (!journeyExists) {
        return state
      }

      const newHistory = state.history.filter((journey) => journey !== action.name)
      const newJourneys = { ...state.journeys }
      delete newJourneys[action.name]

      return {
        ...state,
        history: newHistory,
        active: newHistory.length > 0 ? newHistory[newHistory.length - 1] : undefined,
        journeys: newJourneys,
      }
    }
    case 'USER_JOURNEY_ADD_FRUSTRATION': {
      if (!journeyExists) {
        return state
      }
      const signal = sanitizeSignal(action.frustration)
      if (state.journeys[action.name].frustrations.includes(signal)) {
        return state
      }

      return {
        ...state,
        journeys: {
          ...state.journeys,
          [action.name]: {
            ...state.journeys[action.name],
            frustrations: [...state.journeys[action.name].frustrations, signal],
          },
        },
      }
    }
    case 'USER_JOURNEY_ADD_FRICTION': {
      if (!journeyExists) {
        return state
      }
      const signal = sanitizeSignal(action.friction)
      if (state.journeys[action.name].frictions.includes(signal)) {
        return state
      }
      return {
        ...state,
        journeys: {
          ...state.journeys,
          [action.name]: {
            ...state.journeys[action.name],
            frictions: [...state.journeys[action.name].frictions, signal],
          },
        },
      }
    }
    case 'USER_JOURNEY_ADD_TAG': {
      if (!journeyExists || !isAllowedTag(action.tag) || state.journeys[action.name].tags.includes(action.tag)) {
        return state
      }
      return {
        ...state,
        journeys: {
          ...state.journeys,
          [action.name]: { ...state.journeys[action.name], tags: [...state.journeys[action.name].tags, action.tag] },
        },
      }
    }
    case 'USER_JOURNEY_SET_VARIANT': {
      if (!journeyExists) {
        return state
      }
      return {
        ...state,
        journeys: {
          ...state.journeys,
          [action.name]: {
            ...state.journeys[action.name],
            variant: action.variant,
          },
        },
      }
    }

    default:
      return state
  }
}
